module.exports = __webpack_public_path__ + "img/120x35.5e426599.png";